<template>
  <div v-if="superAdmin || userRole == 'admin'">
      <v-layout wrap row justify-start  pa-4>
        <v-flex xs12 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Bulk vendor pricing
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Agent"
										solo
										hide-details
										disabled
                    :loading="loading"
										v-model="userName"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Delimiter"
										solo
										disabled
										hide-details
                    :loading="loading"
										v-model="delimiter"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1 class="text-xs-left">
                  EG. 
                  <div>sku,country,price,active,new_product,best_seller,special_offer,flash_item,flash_hours,flash_start_hours,flash_price,sub_vendor</div>
                  <div>A.22222,SA,22.2,1,1,1,1,0,48,24,22.2,1</div>
                  <div>A.33333,AE,30.3,1,0,1,0,0,48,24,30.3,0</div>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-textarea
										label="sku, country, price, active, new, best_seller, special_offer, flash_item, flash_hours,flash_start_hours,flash_price,sub_vendor"
										v-model="pastedData"
										solo
									></v-textarea>
              	</v-flex>
                <v-flex xs12 class="text-xs-center">
									{{logger}}
								</v-flex>
								<v-flex xs12 class="text-xs-center">
									{{errorLog}}
								</v-flex>
								<v-flex xs12>
									<div v-for="k in pKeys" :key="k">{{k}}</div>
								</v-flex>
              </v-layout>
            </v-card-text>
						<v-card-actions>
              <v-spacer></v-spacer>
							<v-btn @click="sendBulk()" :loading="loading" color="success" dark>
                send
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate, sleep} from '@/customFunction';
import countriesJSON from '@/countries-ash.json'
import axios from 'axios';
import { productApiUrl } from '@/config/urls';
const headers = {
  'Accept': 'application/json'
}
export default {
  data(){
    return {
			loading: false,
			pastedData:null,
			delimiter:',',
			logger:null,
			pKeys:[],
			countriesFullLoaded:countriesJSON,
			taxrates:null,
			last:null,
			limit:3,
			loops:2,
      errorLog:'',
    }
  },
  methods: {
		
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
			var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
		},
		async sendBulk(){
      let data = this.getArray().filter(x=>x.sku && x.country);
      let checkList = ['active', 'new_product', 'best_seller', 'special_offer','flash_item', 'sub_vendor'];
      (async x=>{
        this.logger = `0/${data.length}`
        for (let i = 0; i < data.length; i++) {
          const send = data[i];
          for (const key in send) {
            if (Object.hasOwnProperty.call(send, key)) {
              const val = send[key];
              if(checkList.includes(key)) {
                send[key] = parseInt(val) ? true : false
              } else if (key == 'price') {
                send[key] = parseFloat(val)
              } else if (key == 'flash_price') {
                send[key] = parseFloat(val)
              } else if (key == 'flash_hours') {
                send[key] = parseFloat(val)
              } else if (key == 'flash_start_hours') {
                send[key] = parseFloat(val)
              } 
            }
          }
          await sleep(3000)
        let a = await axios.post(productApiUrl(`bulk-vendor`), send, {headers}).then(x=>x.data)
          if(a.error) {
            this.errorLog += `${send.sku} | ${send.country} | ${a.error}`
          }
          this.logger = `${i+1}/${data.length}`
        }
        console.log(data);
      })()
    }
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
		},
    userRole:{
			default:null
		},
  },
  computed:{
    
  },
  async created(){

  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
